module.exports = __webpack_public_path__ + "style/img/RE_icon_Customers.a9515536.png";